/**
 * 上传锁
 *
 * 同一时间只允许一个上传任务：
 * - 进度提示用的是全局 message，并发上传会互相 destroy，进度显示错乱；
 * - 指令在配置（binding.value）变化时会重建 uploadMask 实例，
 *   所以锁必须放在模块级跨实例共享，不能用组件内部的 ref。
 */

let uploading = false

/** 当前是否有上传任务在进行中 */
export const isUploading = () => uploading

/** 占用上传锁 */
export const lockUpload = () => {
  uploading = true
}

/** 释放上传锁 */
export const unlockUpload = () => {
  uploading = false
}
